import { createReducer, on } from "@ngrx/store";
import { SettingsActions } from "../actions";

export interface SettingsState {
  isChangingPassword: boolean;
  isResettingPassword: boolean;
  isChangingLanguage: boolean;
}

const initialState = {
  isChangingPassword: false,
  isResettingPassword: false,
  isChangingLanguage: false,
} as SettingsState;

export const settingsReducer = createReducer(
  initialState,
  on(SettingsActions.changePassword, (state, _) => ({
    ...state,
    isChangingPassword: true,
  })),
  on(SettingsActions.changedPassword, () => ({
    ...initialState,
    isChangingPassword: false,
  })),
  on(SettingsActions.changePasswordFailed, () => ({
    ...initialState,
    isChangingPassword: false,
  })),
  on(SettingsActions.resetPassword, (state, _) => ({
    ...state,
    isResettingPassword: true,
  })),
  on(SettingsActions.resetPasswordSuccessfully, () => ({
    ...initialState,
    isResettingPassword: false,
  })),
  on(SettingsActions.resetPasswordFailed, () => ({
    ...initialState,
    isResettingPassword: false,
  })),
  on(SettingsActions.changeLanguage, (state, _) => ({
    ...state,
    isChangingLanguage: true,
  })),
  on(SettingsActions.changedLanguage, () => ({
    ...initialState,
    isChangingLanguage: false,
  })),
  on(SettingsActions.changeLanguageFailed, () => ({
    ...initialState,
    isChangingLanguage: false,
  })),
);
